module.exports = __webpack_public_path__ + "img/squelette-anatomie-dos.82a20725.png";